import LocalRepository from "./local-repository";

export { LocalRepository };
